module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "申报时间",
      "prop": "year",
      "rules": [{
        required: true,
        message: '请选择年份',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.formData.year),
      callback: function($$v) {
        _vm.$set(_vm.formData, "year", $$v)
      },
      expression: "formData.year"
    }
  }, _vm._l((_vm.columns), function(item) {
    return _c('el-radio', {
      key: item,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取的比赛或活动名称"
    }
  }, [(_vm.formData.extra_saiqu.length > 0) ? _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.formData.extra_saiqu[0].name) + "\n            ")]) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.showSaiquPicker = true
      }
    }
  }, [_vm._v("点击选择领取的比赛或活动名称 "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])])], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取地址",
      "prop": "area",
      "rules": [{
        required: true,
        message: '点击选择省市区',
      } ]
    }
  }, [_c('el-cascader', {
    ref: "areas",
    attrs: {
      "options": _vm.areaOptions,
      "props": {
        label: 'title'
      }
    },
    on: {
      "change": _vm.handleAreasChange
    },
    model: {
      value: (_vm.formData.area),
      callback: function($$v) {
        _vm.$set(_vm.formData, "area", $$v)
      },
      expression: "formData.area"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取日期",
      "prop": "getdate",
      "rules": [{
        required: true,
        message: '请选择领取日期',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-date-picker', {
    attrs: {
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "type": "date",
      "placeholder": "请选择领取日期"
    },
    model: {
      value: (_vm.formData.getdate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "getdate", $$v)
      },
      expression: "formData.getdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "领取单位",
      "prop": "danwei",
      "rules": [{
        required: true,
        message: '单位名称不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人",
      "prop": "name",
      "rules": [{
        required: true,
        message: '联系人名称不能为空',
        trigger: 'blur'
      } ]
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入联系人名称"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "phone",
      "rules": []
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.formData.member_list), function(subject, index) {
    return _c('div', [_c('el-divider', [_vm._v("四好运动员信息" + _vm._s(index + 1))]), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "姓名",
        "prop": 'member_list.' + index + '.name',
        "rules": [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入姓名"
      },
      model: {
        value: (subject.name),
        callback: function($$v) {
          _vm.$set(subject, "name", $$v)
        },
        expression: "subject.name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "身份证号",
        "prop": 'member_list.' + index + '.num',
        "rules": [{
          required: true,
          validator: _vm.validator.idCard,
          message: '请输入正确的身份证号',
          trigger: ['blur', 'change']
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入身份证号"
      },
      model: {
        value: (subject.num),
        callback: function($$v) {
          _vm.$set(subject, "num", $$v)
        },
        expression: "subject.num"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "民族",
        "prop": 'member_list.' + index + 'mingzu'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入民族"
      },
      model: {
        value: (subject.mingzu),
        callback: function($$v) {
          _vm.$set(subject, "mingzu", $$v)
        },
        expression: "subject.mingzu"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "学段",
        "prop": 'member_list.' + index + 'xueduan',
        "rules": []
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入学段"
      },
      model: {
        value: (subject.xueduan),
        callback: function($$v) {
          _vm.$set(subject, "xueduan", $$v)
        },
        expression: "subject.xueduan"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "form-label-desc mt10"
    }, [_vm._v("“学段”可填：幼儿园、小学、初中、高中、大学")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "品德得分",
        "prop": 'member_list.' + index + 'score_pingde'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "请输入品德得分"
      },
      model: {
        value: (subject.score_pingde),
        callback: function($$v) {
          _vm.$set(subject, "score_pingde", $$v)
        },
        expression: "subject.score_pingde"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "学段得分",
        "prop": 'member_list.' + index + 'score_xuexi',
        "rules": []
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "请输入学段得分"
      },
      model: {
        value: (subject.score_xuexi),
        callback: function($$v) {
          _vm.$set(subject, "score_xuexi", $$v)
        },
        expression: "subject.score_xuexi"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "气质得分",
        "prop": 'member_list.' + index + 'score_qizhi'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "请输入气质得分"
      },
      model: {
        value: (subject.score_qizhi),
        callback: function($$v) {
          _vm.$set(subject, "score_qizhi", $$v)
        },
        expression: "subject.score_qizhi"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "技术得分",
        "prop": 'member_list.' + index + 'score_jishu',
        "rules": []
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入技术得分"
      },
      model: {
        value: (subject.score_jishu),
        callback: function($$v) {
          _vm.$set(subject, "score_jishu", $$v)
        },
        expression: "subject.score_jishu"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "投票得分",
        "prop": 'member_list.' + index + 'score_toupiao'
      }
    }, [_c('el-input', {
      attrs: {
        "type": "number",
        "placeholder": "请输入投票得分"
      },
      model: {
        value: (subject.score_toupiao),
        callback: function($$v) {
          _vm.$set(subject, "score_toupiao", $$v)
        },
        expression: "subject.score_toupiao"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "footer-button"
    }, [_c('el-button', {
      attrs: {
        "size": "normal",
        "round": "",
        "icon": "el-icon-close"
      },
      on: {
        "click": function($event) {
          return _vm.memberRemove(subject, index)
        }
      }
    }, [_vm._v("删除运动员\n          ")])], 1)], 1)
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "round": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.memberAdd
    }
  }, [_vm._v("新增运动员\n          ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm')
      }
    }
  }, [_vm._v("提交申请")])], 1)], 1)], 2), _vm._v(" "), _c('SaiquPicker', {
    attrs: {
      "show": _vm.showSaiquPicker,
      "limit": 1,
      "value": _vm.formData.extra_saiqu,
      "defaultValue": _vm.formData.extra_saiqu
    },
    on: {
      "onChange": _vm.onSaiquChange,
      "onClose": function($event) {
        _vm.showSaiquPicker = false
      },
      "onConfirm": _vm.onSaiquConfirm
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88210556","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubDetailSihaoApply.vue
// module id = 1509
// module chunks = 0